import { Router } from '@angular/router';
import { UtilsService } from './../../core/services/utils.service';
import { Denounce } from './../../core/models/denounce.model';
import { Component, OnInit } from '@angular/core';
import { MapsAPILoader } from '@agm/core';
import { ComplaintsService } from '../../core/services/complaints.service';
import { MatDialog } from '@angular/material/dialog';
import { EmergencyMeaningComponent } from '../../components/modals/emergency-meaning/emergency-meaning.component';
import { UserService } from '../../core/services/user.service';

@Component({
	selector: 'app-real-time',
	templateUrl: './real-time.component.html',
	styleUrls: ['./real-time.component.scss'],
})
export class RealTimeComponent implements OnInit {
	public center = { lat: -3.71839, lng: -38.5434 };
	public map: google.maps.Map;
	public markers = [];
	loading = false;

	complaints: Denounce[] = [];
	emergencies: Denounce[] = [];

	constructor(
		public utils: UtilsService,
		private router: Router,
		public mapsAPILoader: MapsAPILoader,
		private complaintsService: ComplaintsService,
		public dialog: MatDialog,
		private userService: UserService
	) {}

	ngOnInit(): void {
		this.loading = true;
		this.getEmergencies();
		this.getCurrentEmergencies();

		const spUser = localStorage.getItem('sp-user');

		if (spUser === null) {
			this.userService.getSelfUserOp().subscribe((user) => {
				const locale = user.UserAttributes.find(
					(attr) => attr.Name === 'locale'
				).Value;

				if (locale == 'e1a0c005-8a02-4930-b8af-f8a77c2524ed') {
					localStorage.setItem('sp-user', 'true');

					this.center = { lat: -23.55617195585249, lng: -46.63761818550684 };
				} else {
					localStorage.setItem('sp-user', 'false');
				}
			});
		} else {
			if (spUser === 'true') {
				this.center = { lat: -23.55617195585249, lng: -46.63761818550684 };
			}
		}

		const emergencyAlert = localStorage.getItem('emergencyMeaningAlert');

		if (emergencyAlert == 'false') {
			this.dialog.open(EmergencyMeaningComponent);
			localStorage.setItem('emergencyMeaningAlert', 'true');
		}

		setInterval(() => {
			this.getCurrentEmergencies();
			this.getEmergencies();
		}, 30000);
	}

	public async getEmergencies() {
		this.complaintsService.getEmergencies().subscribe((data) => {
			this.complaints = data.complaints;
		});
	}

	public async getCurrentEmergencies() {
		this.complaintsService.getEmergencies('ALL', true).subscribe((data) => {
			this.emergencies = data.complaints;

			this.setMap().then(() => (this.loading = false));
		});
	}

	private async setMarkers() {
		this.markers = [];

		if (!this.emergencies || this.emergencies.length == 0) return;
		this.emergencies.forEach((emergency: any) => {
			this.markers.push({
				lat: emergency.address_coordinates.coordinates[0],
				lng: emergency.address_coordinates.coordinates[1],
			});
		});

		return;
	}

	oldEmergencies = [];

	public async setMap() {
		const newEmergencies = this.emergencies.filter((emergency) => {
			return !this.oldEmergencies.find(
				(oldEmergency) => oldEmergency._id == emergency._id
			);
		});

		if (newEmergencies.length == 0) return;
		this.oldEmergencies = this.emergencies;

		this.setMarkers();

		await this.mapsAPILoader.load().then(() => {
			const map = document.getElementById('emergencies-map') as HTMLElement;

			this.map = new google.maps.Map(map, {
				zoom: 13,
				center: this.center,
				mapTypeControl: false,
			});
		});

		this.markers.map((marker) => {
			return new google.maps.Marker({
				position: { lat: marker.lat, lng: marker.lng },
				map: this.map,
				title: '',
				icon: {
					url: 'assets/icons/emergency-pin.png',
					scaledSize: new google.maps.Size(40, 40),
				},
			});
		});

		return;
	}

	goToDetails(element: Denounce) {
		this.router.navigate(['/home/ocurrences-details', element._id]);
	}
}
